import { PatternBackground } from 'app/components/primitive/PatternBackground'

export type BannerPatternType = 'none' | 'pink' | 'darkGreen' | 'cream' | 'blue'

export const PATTERN_COLORS: Record<
  Exclude<BannerPatternType, 'none'>,
  { bg: string; color: string }
> = {
  pink: { bg: '#FFBBE7', color: '#F8B1E3' },
  darkGreen: { bg: '#435F49', color: '#3D543F' },
  cream: { bg: '#F7F6ED', color: '#E5E4E1' },
  blue: { bg: '#C5D1FF', color: '#BBC9F1' },
}

export interface BannerPatternProps {
  backgroundPattern?: BannerPatternType
  tileSize?: number
  opacity?: number
  zIndex?: number
}

export const BannerPattern = ({
  backgroundPattern,
  tileSize = 100,
  opacity = 1,
  zIndex = -1,
}: BannerPatternProps) => {
  if (!backgroundPattern || backgroundPattern === 'none') {
    return null
  }

  return (
    <PatternBackground
      color={PATTERN_COLORS[backgroundPattern].color}
      tileSize={tileSize}
      zIndex={zIndex}
      opacity={opacity}
    />
  )
}
